import React from 'react';
import tw from 'twin.macro';
import { css } from '@emotion/react';
import { BtnPrimary, Ribbon } from './scaffolds';
import { DateTime } from 'luxon';

const ProductContainer = tw.div`
  flex-wrap lg:flex lg:justify-start mb-4 text-left
`;

const ProductBox: React.FC<{ style?: React.CSSProperties; className?: string; id?: string }> = ({
  children,
  style,
  className,
  id,
}) => (
  <div id={id} style={style} className={className}>
    <div tw="bg-white dark:bg-black-300 w-full h-full p-6 rounded-3xl flex flex-col justify-between">
      {children}
    </div>
  </div>
);

const TimeBox: React.FC<{ style?: React.CSSProperties; className?: string; id?: string }> = ({
  children,
  style,
  className,
  id,
}) => (
  <div id={id} style={style} className={className}>
    <div tw="bg-white dark:bg-black-300 p-1 rounded-lg flex flex-col justify-between mx-1 text-black-100 dark:text-white">
      {children}
    </div>
  </div>
);

interface PackageProps {
  id?: string;
  title?: any;
  leftSubtitle?: any;
  leftContents?: PackageLeftContent[];
  products?: Product[];
  notes?: string;
  periodeWaktu?: Date;
  periodeWaktuEnd?: Date;
  periodeWaktuLabelOpened?: string;
  periodeWaktuLabelOnGoing?: string;
  periodeWaktuLabelClosed?: string;
}

interface timeCountdown {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}

interface PackageState {
  hoveringBenefit?: number;
  promoEnd?: string[];
  periodStart?: timeCountdown;
  periodEnd?: timeCountdown;
  periodeLabel?: string;
  disableProductButton?: boolean;
  width?: number;
  products?: Product[][];
  productsLimit?: number[];
}

export interface PackageLeftContent {
  title?: string;
  detail?: any;
}

export interface SubtitleProduct {
  text: string;
  items?: any[];
}

export interface Product {
  title?: string;
  subtitle?: SubtitleProduct;
  estimation?: any;
  category?: string;
  ribbon?: any;
  ribbonStyle?: string;
  color?: string;
  darkColor?: string;
  promoEnd?: string;
  price?: string;
  specialPrice?: string;
  link?: string;
  startFrom?: boolean;
  tAC?: boolean;
  onLinkClicked?: any;
  linkText?: any;
  linkClass?: any;
  periode?: boolean;
}

class Package extends React.Component<PackageProps, PackageState> {
  timer!: NodeJS.Timer;
  test = 0;
  limit = 3;
  constructor(props: PackageProps) {
    super(props);
    this.state = {
      hoveringBenefit: null,
      promoEnd: this.props.products?.map(p => {
        if (!p.promoEnd || p.promoEnd === '') {
          return null;
        }
        return this.getCountdown(p.promoEnd);
      }),
      periodStart: this.checkFuture(this.props.periodeWaktu, true),
      periodEnd: this.checkFuture(this.props.periodeWaktuEnd, true),
      disableProductButton: this.disableProductButton(),
      periodeLabel: this.setPeriodLabel(),
      width: typeof window !== 'undefined' ? window.innerWidth : 0,
      products: this.categorizeProduct(this.props.products, 'category'),
      productsLimit:
        typeof window !== 'undefined' && window.innerWidth < 1024
          ? [this.limit, this.limit, this.limit]
          : [10, 10, 10],
    };
  }

  categorizeProduct(products: Product[], categoryParam: string) {
    const categories = {};
    for (var i = 0; i < products.length; i++) {
      var item = products[i];
      var e = item[categoryParam];
      if (!(e in categories)) categories[e] = [];
      categories[e].push(item);
    }

    let orderArr = ['Izin Kategori Pangan', 'Izin Kategori Teknologi', 'Izin Kategori Lainnya'];
    const ordered = orderArr.map(property => categories[property]);

    return ordered;
  }

  minifyProduct(products: Product[], index: number) {
    const newProducts = [...products];
    const minify = newProducts.splice(0, this.state.productsLimit[index]);
    return minify;
  }

  toggleProduct(index: number) {
    const limit = this.state.productsLimit;
    limit[index] = limit[index] === this.limit ? 10 : this.limit;
    this.setState({
      productsLimit: limit,
    });
  }

  getSufixPrice(price: string) {
    if (!price) {
      return '';
    }
    let num = parseInt(price);
    let sufix = num / 1000 >= 1000 ? 'juta' : 'ribu';
    return sufix;
  }

  formatPrice(price: string) {
    if (!price) {
      return '';
    }
    let num = parseInt(price);
    num = num / 1000 >= 1000 ? num / 1000000 : num / 1000;

    let formattedPrice = num.toString();
    return formattedPrice.replace('.', ',');
  }

  convertToKebabCase(source: string) {
    if (!source) {
      return source;
    }
    let text = source;
    if (text[text.length - 2] === ' ' || text[text.length - 3] === ' ') {
      text = text.slice(0, -2);
    }
    if (text[text.length - 1] === ' ') {
      text = text.slice(0, -1);
    }

    return text.toLocaleLowerCase().replace(/ /g, '-');
  }

  componentDidMount() {
    this.tick();
    window.addEventListener('resize', () => {
      this.setState({
        width: window.innerWidth,
        productsLimit:
          typeof window !== 'undefined' && window.innerWidth < 1024
            ? [this.limit, this.limit, this.limit]
            : [10, 10, 10],
      });
    });
  }

  componentWillUnmount() {
    this.resetTick();
    window.addEventListener('resize', () => {
      this.setState({
        width: window.innerWidth,
        productsLimit:
          typeof window !== 'undefined' && window.innerWidth < 1024
            ? [this.limit, this.limit, this.limit]
            : [10, 10, 10],
      });
    });
  }

  tick() {
    this.resetTick();
    this.timer = setInterval(() => {
      this.setState({
        promoEnd: this.props.products?.map(p => {
          if (!p.promoEnd || p.promoEnd === '') {
            return null;
          }
          const promo = DateTime.fromFormat(p.promoEnd, 'dd/MM/yyyy').toJSDate();
          return this.getCountdown(promo);
        }),
        periodStart: this.checkFuture(this.props.periodeWaktu, true),
        periodEnd: this.checkFuture(this.props.periodeWaktuEnd, true),
        disableProductButton: this.disableProductButton(),
        periodeLabel: this.setPeriodLabel(),
      });
    }, 1000);
  }

  resetTick() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  getCountdown(date) {
    if (!date) {
      return null;
    }
    const dDay = DateTime.fromJSDate(date);
    const now = DateTime.local();
    const cntd = dDay.diff(now, ['days', 'hours', 'minutes', 'seconds']);
    if (cntd.days < 0 || cntd.hours < 0 || cntd.minutes < 0 || cntd.seconds < 0) {
      return '0:0:0';
    }
    const hour = `${cntd.hours < 10 ? '0' + cntd.hours : cntd.hours}:${
      cntd.minutes < 10 ? '0' + cntd.minutes : cntd.minutes
    }:${
      parseInt(cntd.seconds.toString(), 10) < 10
        ? '0' + parseInt(cntd.seconds.toString())
        : parseInt(cntd.seconds.toString())
    }`;

    if (cntd.days < 1) {
      return hour;
    }

    return `${cntd.days} Hari ${hour}`;
  }

  disableProductButton(): boolean {
    const timeStart = this.props.periodeWaktu;
    const timeEnd = this.props.periodeWaktuEnd;
    if (!timeStart || !timeEnd) {
      return false;
    }

    const start = DateTime.fromJSDate(new Date(timeStart));
    const now = DateTime.local();
    const end = DateTime.fromJSDate(new Date(timeEnd));

    if (now.toJSDate() < start.toJSDate()) {
      return true;
    }

    const cntd = end.diff(now, ['minutes']);
    if (cntd.minutes > 0 && cntd.minutes < 24 * 60) {
      return false;
    }

    if (now.toJSDate() >= start.toJSDate() && now.toJSDate() <= end.toJSDate()) {
      return false;
    }

    return true;
  }

  setPeriodLabel(): string {
    const timeStart = this.props.periodeWaktu;
    const timeEnd = this.props.periodeWaktuEnd;

    if (!timeStart || !timeEnd) {
      return '';
    }

    const start = DateTime.fromJSDate(new Date(timeStart));
    const now = DateTime.local();
    const end = DateTime.fromJSDate(new Date(timeEnd));

    if (now.toJSDate() < start.toJSDate()) {
      return this.props.periodeWaktuLabelOpened;
    }

    const cntd = end.diff(now, ['minutes']);
    if (cntd.minutes > 0 && cntd.minutes < 24 * 60) {
      return this.props.periodeWaktuLabelClosed;
    }

    if (now.toJSDate() >= start.toJSDate() && now.toJSDate() <= end.toJSDate()) {
      return this.props.periodeWaktuLabelOnGoing;
    }

    return '';
  }

  checkFuture(time = null, format = false): timeCountdown {
    if (!time) {
      return null;
    }

    const dDay = DateTime.fromJSDate(new Date(time));
    const now = DateTime.local();
    const cntd = dDay.diff(now, ['days', 'hours', 'minutes', 'seconds']);

    const days = cntd.days > 0 ? `${cntd.days < 10 ? '0' + cntd.days : cntd.days}` : '00';
    const hours = cntd.hours > 0 ? `${cntd.hours < 10 ? '0' + cntd.hours : cntd.hours}` : '00';
    const minutes =
      cntd.minutes > 0 ? `${cntd.minutes < 10 ? '0' + cntd.minutes : cntd.minutes}` : '00';
    const seconds =
      cntd.seconds > 0
        ? parseInt(cntd.seconds.toString(), 10) < 10
          ? '0' + parseInt(cntd.seconds.toString())
          : parseInt(cntd.seconds.toString())
        : '00';

    if (format) {
      return {
        days,
        hours,
        minutes,
        seconds: seconds.toString(),
      };
    }

    return {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
    };
  }

  render() {
    return (
      <section tw="bg-blue-sky dark:bg-black-200 relative" id={this.props.id}>
        <div
          
        >
          <div tw="container relative z-10">
            <div tw="lg:text-center mx-8 lg:mx-32 lg:text-center py-12">
              <h2 id="product" tw="text-black-100 dark:text-white mb-8">
                {this.props.title}
              </h2>
              {this.props.periodeWaktu &&
              this.props.periodeWaktuEnd &&
              this.state.periodeLabel !== '' ? (
                <div tw="w-full mb-8">
                  <div tw="flex align-baseline text-white justify-center">
                    <span tw="mt-1">{this.state.periodeLabel}</span>
                    {this.state.periodeLabel === this.props.periodeWaktuLabelClosed ? (
                      <div tw="flex align-baseline mx-1">
                        <div>
                          <TimeBox>{this.state.periodEnd?.hours}</TimeBox>{' '}
                          <span tw="text-xs">Jam</span>
                        </div>
                        <span tw="mt-1">:</span>
                        <div>
                          <TimeBox>{this.state.periodEnd?.minutes}</TimeBox>{' '}
                          <span tw="text-xs">Menit</span>
                        </div>
                        <span tw="mt-1">:</span>
                        <div>
                          <TimeBox>{this.state.periodEnd?.seconds}</TimeBox>{' '}
                          <span tw="text-xs">Detik</span>
                        </div>
                      </div>
                    ) : this.state.periodeLabel === this.props.periodeWaktuLabelOpened ? (
                      <div tw="flex align-baseline mx-1">
                        <div>
                          <TimeBox>{this.state.periodStart?.days}</TimeBox>{' '}
                          <span tw="text-xs">Hari</span>
                        </div>
                        <span tw="mt-1">:</span>
                        <div>
                          <TimeBox>{this.state.periodStart?.hours}</TimeBox>{' '}
                          <span tw="text-xs">Jam</span>
                        </div>
                        <span tw="mt-1">:</span>
                        <div>
                          <TimeBox>{this.state.periodStart?.minutes}</TimeBox>{' '}
                          <span tw="text-xs">Menit</span>
                        </div>
                      </div>
                    ) : (
                      <div tw="flex align-baseline mx-1">
                        <div>
                          <TimeBox>{this.state.periodEnd?.days}</TimeBox>{' '}
                          <span tw="text-xs">Hari</span>
                        </div>
                        <span tw="mt-1">:</span>
                        <div>
                          <TimeBox>{this.state.periodEnd?.hours}</TimeBox>{' '}
                          <span tw="text-xs">Jam</span>
                        </div>
                        <span tw="mt-1">:</span>
                        <div>
                          <TimeBox>{this.state.periodEnd?.minutes}</TimeBox>{' '}
                          <span tw="text-xs">Menit</span>
                        </div>
                      </div>
                    )}

                    <span tw="mt-1">lagi</span>
                  </div>
                </div>
              ) : (
                <div tw="mb-8"></div>
              )}

              <div id="product-item-container">
                <div tw="mr-4 text-left lg:text-center">
                  <div
                    tw="text-b1 text-black-100 dark:text-white mb-8"
                  >
                    {this.props.leftSubtitle}
                  </div>
                </div>
                <div tw="flex flex-col justify-between">
                  {this.state.products.map((products, j) => (
                    <div
                      key={'product-wrapper' + j}
                      css={css`
                        .separator {
                          ${tw`text-blue-marine dark:text-white font-medium`}
                        }

                        .separator::after {
                          content: '';
                          flex: 1;
                          ${tw`border border-dashed border-black-500 dark:border-white`}
                        }

                        .separator:not(:empty)::after {
                          ${tw`ml-2 mr-4`}
                        }
                      `}
                    >
                      <div className="separator" tw="flex text-left items-center my-2">
                        <span tw="text-b0 ml-2 mr-2 font-medium">{products[0]?.category}</span>
                      </div>
                      <ProductContainer>
                        {this.minifyProduct(products, j).map((item, i) => (
                          <ProductBox
                            tw="w-full lg:w-1/3 pb-4 lg:p-2 relative mb-6 lg:mb-4"
                            key={'products' + i}
                            id={this.convertToKebabCase(item.title)}
                          >
                            <div tw="text-black-100 dark:text-white">
                              <h3 tw="text-h3 mb-2 font-extrabold">{item.title}</h3>
                              {item.ribbon ? (
                                <Ribbon
                                  css={css`
                                    ${item.ribbonStyle === 'bg-red'
                                      ? tw`bg-red`
                                      : tw`bg-blue-lapis dark:bg-white dark:text-blue-lapis`}
                                  `}
                                >
                                  {item.ribbon} {this.state?.promoEnd[i]}
                                </Ribbon>
                              ) : (
                                <div></div>
                              )}
                              <div tw="text-h4 mb-2">
                                {item?.subtitle?.items?.length > 0 ? (
                                  <ul
                                    tw="list-none m-0 my-3"
                                    css={css`
                                      li {
                                        ${tw`m-0`}
                                      }
                                      ul {
                                        ${tw`mt-0`}
                                      }
                                    `}
                                  >
                                    {item?.subtitle?.items?.map((it, i) => {
                                      return (
                                        <li key={i + '-it'}>
                                          <b
                                            tw="text-black-100"
                                            css={css`
                                              ${it.list === '✔' ? tw`text-black-100` : tw`text-red`}
                                            `}
                                          >
                                            {it.list}
                                          </b>{' '}
                                          {it.text}
                                        </li>
                                      );
                                    })}
                                  </ul>
                                ) : (
                                  <div
                                    dangerouslySetInnerHTML={{ __html: item?.subtitle?.text }}
                                  ></div>
                                )}
                              </div>
                              <div tw="text-b3 text-black-300 dark:text-white mb-2 mt-2">
                                {item.estimation}
                              </div>
                            </div>
                            <div tw="m-0">
                              <p tw="mb-0 mt-2 text-b3 font-bold text-blue-black dark:text-white">
                                {item.startFrom ? 'Mulai dari' : ''}
                              </p>
                              {!item.specialPrice ? (
                                <div tw="flex items-baseline text-blue-black dark:text-white">
                                  {item.price ? (
                                    <h2 tw="m-0">
                                      Rp
                                      {this.formatPrice(item.price)}{' '}
                                      <b tw="text-h4">{this.getSufixPrice(item.price)}</b>
                                    </h2>
                                  ) : (
                                    <h2 tw="m-0">Tanya Sales Kami</h2>
                                  )}
                                </div>
                              ) : (
                                <div tw="flex items-baseline text-blue-black dark:text-white flex-wrap">
                                  <div
                                    tw="text-black-300 dark:text-black-700 flex items-baseline relative opacity-70"
                                    css={css`
                                      &:after {
                                        border-bottom: 3px solid;
                                        content: '';
                                        left: 0;
                                        position: absolute;
                                        right: 0;
                                        top: 33%;
                                        width: 98%;
                                        ${tw`border-black-300 dark:border-black-700`}
                                      }
                                    `}
                                  >
                                    <h2 tw="m-0">
                                      Rp {this.formatPrice(item.price)}{' '}
                                      <b tw="text-h4">{this.getSufixPrice(item.price)}</b>
                                    </h2>
                                  </div>
                                  <div tw="flex items-baseline">
                                    <h2 tw="m-0">
                                      Rp {this.formatPrice(item.specialPrice)}{' '}
                                      <b tw="text-h4">
                                        {this.getSufixPrice(item.price)}
                                        {item.tAC ? '*' : ''}
                                      </b>
                                    </h2>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div
                              tw="absolute w-full px-6"
                              css={css`
                                right: 0;
                                bottom: -0.2rem;
                              `}
                            >
                              <BtnPrimary
                                className={item.linkClass || 'gtm-call-button'}
                                href={item.link}
                                target="__blank"
                                tw="w-1/2 lg:w-2/5 text-center dark:border-black-300 px-1 flex items-center justify-center float-right"
                                css={css`
                                  border: 4px solid white;
                                  padding-top: 10px;
                                  padding-bottom: 10px;
                                  ${this.state.disableProductButton && item.periode
                                    ? 'pointer-events: none;cursor: default;'
                                    : ''}
                                  ${this.state.disableProductButton && item.periode
                                    ? tw`bg-black-700 hover:bg-black-700 active:bg-black-700 text-black-500`
                                    : ''}
                                `}
                                onClick={item.onLinkClicked}
                              >
                                {item.linkText || 'Konsultasi'}
                                <span
                                  tw="text-black-100 font-extrabold"
                                  className="icon icon-chevron-right"
                                  aria-label="arrow-right"
                                ></span>
                              </BtnPrimary>
                            </div>
                          </ProductBox>
                        ))}
                      </ProductContainer>
                      {typeof window !== 'undefined' &&
                      window.innerWidth < 1024 &&
                      products.length > this.limit ? (
                        <div
                          tw="font-extrabold font-gilroy text-center text-blue-lapis dark:text-yellow-bright mb-4"
                          onClick={() => {
                            this.toggleProduct(j);
                          }}
                        >
                          <span tw="m-0 text-h4 underline cursor-pointer text-center">
                            {this.state.productsLimit[j] !== this.limit
                              ? 'Lihat lebih sedikit'
                              : `Lihat ${products.length - this.limit} paket lainnya`}
                          </span>
                          <span
                            tw="ml-1 text-h4 font-extrabold"
                            className={
                              this.state.productsLimit[j] !== this.limit
                                ? 'icon icon-chevron-up'
                                : 'icon icon-chevron-down'
                            }
                          ></span>
                        </div>
                      ) : null}
                    </div>
                  ))}
                  <p tw="text-center lg:text-right text-b3 text-black-200 dark:text-white mb-4">{this.props.notes}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Package;
